export function normalizeApostrophes(str?: string): string {
  if (!str) return "";
  return str.replace(/[’‘`´]/g, "'").trim();
}
